import {Select} from '@mantine/core'
import type {FormValues} from './FormValues.ts'
import {timezones} from '@package/shared'
import {weekdays} from '../../calendar/formatter/weekdays.ts'
import type {UseFormReturnType} from '@mantine/form'

type Props = {
  form: UseFormReturnType<FormValues>
  disabled: boolean
}

export const FormFields = ({form, disabled: containerDisabled}: Props) => {
  const disabled = containerDisabled

  return (
    <>
      <Select
        label={'Timezone'}
        data={timezones}
        key={form.key('timezone')}
        {...form.getInputProps('timezone')}
        searchable
        required
        disabled={disabled}
      />

      <Select
        label={'First day of week'}
        data={weekdays.map((weekday, i) => ({
          value: `${i}`,
          label: weekday,
        }))}
        key={form.key('firstDayOfWeek')}
        {...form.getInputProps('firstDayOfWeek')}
        value={`${form.values.firstDayOfWeek}`}
        onChange={(value) => value && form.setFieldValue('firstDayOfWeek', Number.parseInt(value))}
        required
        disabled={disabled}
      />

      <Select
        label={'Time format'}
        data={[
          {
            value: '12h',
            label: '01:00 PM',
          },
          {
            value: '24h',
            label: '13:00',
          },
        ]}
        key={form.key('timeFormat')}
        {...form.getInputProps('timeFormat')}
        required
        disabled={disabled}
      />
    </>
  )
}
